<ng-container *ngrxLet="loadingInformationTab$; let loading">
  @if (detailsContent && !loading) {
    <div class="information-container">
      <div class="list">
        <table class="information-table">
          @for (entry of detailInformationEntries; track entry) {
            @if (!hideRow(entry) && (entry.key !== informationKeys.SPORT || entry.content)) {
              <tr>
                <td class="label">{{ entry.label }}<span class="h-offscreen">:</span></td>
                @if (entry.type === 'standard' || entry.type === 'constraints') {
                  <td
                    [ngClass]="{ 'with-restrictions': entry.type === 'constraints' }"
                    >
                    <app-highlight [text]='entry.content' [keywords]='keywords'></app-highlight>
                  </td>
                }
                @if (entry.key === informationKeys.DURATION) {
                  <td>
                    <div class="h-offscreen">
                      {{ getAccessibilityDurationString(entry.content) }}
                    </div>
                    <div aria-hidden="true">
                      @if (entry.content) {
                        <app-highlight  [text]='(entry.content | durationFormatPipe)' [keywords]='keywords'></app-highlight>
                      }
                    </div>
                  </td>
                }
                @if (entry.key === informationKeys.SPORT) {
                  <td>
                    <table class="sport-information-table">
                      @for (entry of entry.content; track entry; let i = $index) {
                        <tr>
                          <td>
                            <app-highlight [text]='entry.rank' [keywords]='keywords'></app-highlight>
                          </td>
                          <td>
                            <app-highlight [text]='entry.person' [keywords]='keywords'></app-highlight>
                          </td>
                          <td>
                            <app-highlight [text]='entry.team' [keywords]='keywords'></app-highlight>
                          </td>
                          <td>
                            <app-highlight [text]='entry.rankingRemark' [keywords]='keywords'></app-highlight>
                          </td>
                          <td>
                            <app-highlight [text]='entry.remark' [keywords]='keywords'></app-highlight>
                          </td>
                        </tr>
                      }
                    </table>
                  </td>
                }
                @if (entry.key === informationKeys.PEOPLE) {
                  <td>
                    <table class="people-information-table">
                      @for (entry of entry.content; track entry; let i = $index) {
                        <tr>
                          <td>
                            <app-highlight [text]='entry.name' [keywords]='keywords'></app-highlight>
                          </td>
                          <td>
                            <app-highlight [text]='entry.role' [keywords]='keywords'></app-highlight>
                          </td>
                        </tr>
                      }
                    </table>
                  </td>
                }
                @if (entry.key === informationKeys.DESCRIPTORS) {
                  <td>
                    @if (entry.content.length > 0) {
                      @for (content of entry.content; track content; let i = $index) {
                        <app-highlight [text]='content' [keywords]='keywords'></app-highlight>
                        @if (i < entry.content.length - 1) {
                          <span>; </span>
                        }
                      }
                    }
                  </td>
                }
                @if (entry.key === informationKeys.FORM) {
                  <td>
                    @if (entry.content.length > 0) {
                      @for (content of entry.content; track content; let i = $index) {
                        <app-highlight [text]='content' [keywords]='keywords'></app-highlight>
                        @if (i < entry.content.length - 1) {
                          <span>; </span>
                        }
                      }
                    }
                  </td>
                }
                @if (entry.key === informationKeys.GEODESCRIPTORS) {
                  <td>
                    @if (entry.content.length > 0) {
                      @for (content of entry.content; track content; let i = $index) {
                        <app-highlight [text]='content' [keywords]='keywords'></app-highlight>
                        @if (i < entry.content.length - 1) {
                          <span>; </span>
                        }
                      }
                    }
                  </td>
                }
                @if (entry.key === informationKeys.DOCUMENTS) {
                  <td>
                    @if (entry.content.length > 0) {
                      @for (entry of entry.content; track entry; let i = $index) {
                        @if (i > 0) {
                          <br />
                          }<button
                          class="info-icon-button"
                          (click)="downloadAttachment(entry.id, entry.filename)"
                          >
                          <img src="assets/icons/arrow-down-circle.svg" alt="Datei Herunterladen" />
                          <app-highlight [text]='entry.name' [keywords]='keywords'></app-highlight>
                        </button>
                      }
                    }
                  </td>
                }
                @if (entry.key === informationKeys.USED_MUSIC) {
                  <td (click)="openMusicDialog()">
                    @if (detailsContent.itemInfo && detailsContent.itemInfo.hasMusic) {
                      <button
                        class="info-icon-button"
                        >
                        <img src="assets/icons/arrow-top-right.svg" alt="Musikliste anzeigen" />Liste
                        anzeigen
                      </button>
                    }
                  </td>
                }
                @if (entry.key === informationKeys.LINKED_ITEMS) {
                  <td>
                    @if (entry.content.length > 0) {
                      @for (entry of entry.content; track entry; let i = $index) {
                        @if (i > 0) {
                          <br />
                        }
                        {{ entry.role }}
                        <a
                          class="icon-link"
                          href="details/{{ entry.programId }}/{{ entry.itemId }}"
                          (click)="goToLinkedItem(entry.programId, entry.itemId, $event)"
                          >
                          <app-highlight [text]='entry.name || "Beitrag"' [keywords]='keywords'></app-highlight>
                        </a>
                      }
                    }
                  </td>
                }
              </tr>
            }
          }
        </table>
      </div>
    </div>
  }
  @if (loading) {
    <div class="loading-container">
      <p-progressSpinner strokeWidth="2" animationDuration="5s" styleClass="custom-spinner"></p-progressSpinner>
    </div>
  }
</ng-container>
